import React from "react";
import {
  Box,
  TextField,
  Chip,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import type { DefaultSportSettings } from "@/types";
import type { SportSettingsFormProps } from "./types";
import { SettingsSection } from "./SettingsSection";
import { SettingsField, SettingsFieldsGrid } from "./SettingsFieldsGrid";

export const DefaultSportSettingsForm: React.FC<SportSettingsFormProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const s = value as DefaultSportSettings;
  const upd = (patch: Partial<DefaultSportSettings>) =>
    onChange({ ...s, ...patch });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SettingsSection title="Очки">
        <SettingsFieldsGrid>
          <SettingsField>
            <TextField
              label="За победу"
              type="number"
              size="small"
              fullWidth
              value={s.pointsWin ?? ""}
              onChange={(e) =>
                upd({
                  pointsWin:
                    e.target.value === "" ? null : parseInt(e.target.value),
                })
              }
              slotProps={{ htmlInput: { min: 0 } }}
              disabled={disabled}
            />
          </SettingsField>
          <SettingsField>
            <TextField
              label="За ничью"
              type="number"
              size="small"
              fullWidth
              value={s.pointsDraw ?? ""}
              onChange={(e) =>
                upd({
                  pointsDraw:
                    e.target.value === "" ? null : parseInt(e.target.value),
                })
              }
              slotProps={{ htmlInput: { min: 0 } }}
              disabled={disabled}
            />
          </SettingsField>
          <SettingsField>
            <TextField
              label="За поражение"
              type="number"
              size="small"
              fullWidth
              value={s.pointsLoss ?? ""}
              onChange={(e) =>
                upd({
                  pointsLoss:
                    e.target.value === "" ? null : parseInt(e.target.value),
                })
              }
              slotProps={{ htmlInput: { min: 0 } }}
              disabled={disabled}
            />
          </SettingsField>
        </SettingsFieldsGrid>
      </SettingsSection>

      <SettingsSection title="Тай-брейки">
        <Autocomplete
          multiple
          freeSolo
          disableCloseOnSelect
          options={[]}
          value={s.tieBreakers ?? []}
          onChange={(_, v) => upd({ tieBreakers: v as string[] })}
          disabled={disabled}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
              {option}
            </li>
          )}
          renderTags={(val, getTagProps) =>
            val.map((opt, idx) => (
              <Chip
                label={`${idx + 1}. ${opt}`}
                size="small"
                {...getTagProps({ index: idx })}
                key={opt}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              fullWidth
              placeholder="Введите критерий и нажмите Enter..."
            />
          )}
        />
      </SettingsSection>
    </Box>
  );
};
